// extracted by mini-css-extract-plugin
export var button = "_co-7";
export var buttonRow = "_co-6";
export var fadeIn = "_co-1";
export var gradient = "_co-0";
export var panel = "_co-2";
export var panelIn = "_co-3";
export var subtitle = "_co-5";
export var title = "_co-4";